import { Grid } from "@material-ui/core";
import styled from "styled-components";

export const MainContainer = styled(Grid)`
    margin-bottom: 40px;
    background-color: white;
    padding: 30px 40px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
`